import React from 'react';
import { useActionsContext } from '../context/ActionsContext';

const RowsPerPage = () => {
  const { rowsPerPage, setRowsPerPage } = useActionsContext();

  return (
    <>
      <select
        className="form-control w-45 m-2"
        data-choices=""
        data-choices-search-false=""
        name="choices-rows-per-page"
        id="idRowsPerPage"
        onChange={(e) => setRowsPerPage(e.target.value)}
        value={rowsPerPage}
      >
        <option value="all">All</option>
        {/* <option value="1">1</option> */}
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="300">300</option>
        <option value="400">400</option>
      </select>
    </>
  );
};

export default RowsPerPage;